export default __webpack_public_path__ + "static/media/specialrule1.0c584318.svg";